var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b7ce3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00baef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8338ec"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(-434 -787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-create",
    transform: "translate(429 781.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1707",
    "data-name": "Path 1707",
    d: "M5,10H57.15V62.15H5Z",
    transform: "translate(0 2.85)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1708",
    "data-name": "Path 1708",
    d: "M45.929,9.933,41.5,5.507a1.725,1.725,0,0,0-2.441,0L36.975,7.59l6.872,6.869,2.082-2.085a1.728,1.728,0,0,0,0-2.441",
    transform: "translate(18.566)",
    fill: "#e57373"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1709",
    "data-name": "Path 1709",
    d: "M0,0H40.666V9.716H0Z",
    transform: "matrix(-0.707, 0.707, -0.707, -0.707, 58.977, 17.896)",
    fill: "#ff9800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1710",
    "data-name": "Path 1710",
    d: "M0,0H4.858V9.717H0Z",
    transform: "translate(52.106 11.028) rotate(-45.025)",
    fill: "#b0bec5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1711",
    "data-name": "Path 1711",
    d: "M17.313,27.152,15,36.334l9.182-2.313Z",
    transform: "translate(5.806 12.861)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1712",
    "data-name": "Path 1712",
    d: "M16.168,30.044,15,34.685l4.641-1.168Z",
    transform: "translate(5.797 14.518)",
    fill: "#37474f"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_429",
    "data-name": "Rectangle 429",
    width: 60,
    height: 60,
    transform: "translate(434 787)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.f291eb4063bf8357948a247426f27c6f.svg";
export { ForwardRef as ReactComponent };